"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getScrollTime_1 = __importDefault(require("./getScrollTime"));
/**
 * Returns the css-transition-string for animating a css-prop while overshooting
 * @param cssProp Which property will animate while scroll-overshoot
 * @param touchActive touchActive-state
 * @param scrollDistance Distance to scroll
 * @param scrollOvershootTime Time the overshoot will take
 * @param speed Speed of scroll events
 */
var getScrollTransition = function (cssProp, touchActive, scrollDistance, scrollOvershootTime, speed) {
    return touchActive
        ? cssProp + " 0ms"
        : cssProp + " " + (scrollOvershootTime !== null && scrollOvershootTime > 50
            ? scrollOvershootTime
            : getScrollTime_1.default(scrollDistance, speed)) + "ms " + (scrollOvershootTime ? 'cubic-bezier(0, 0, 0.36, 1)' : 'ease');
};
exports.default = getScrollTransition;
//# sourceMappingURL=getScrollTransition.js.map